import { defaultFujiProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/fuji/default-constants';

export const JOE_FUJI_CONTRACT_ADDRESS = '0x7b50046cEC8252ca835b148b1eDD997319120a12';
export const JOE_FUJI_PROVIDER_CONFIGURATION = defaultFujiProviderConfiguration;
